import React, { useEffect, useState } from "react";
import { decodeHtml } from "../../../../assests/extention/commonfunction";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { getTeamMembers } from "../../../../redux/team/action";
import { useDispatch, useSelector } from "react-redux";
import { getDateFormate } from "../../../Common/AllDateTimeReleventFormate";
import ReactSelect from "react-select";
import { useNavigate } from "react-router-dom";
import ProfilePic from "../../../../assests/imgs/Profileplaceholder.svg";
import useChatNavigation from "../../../Common/useChatNavigation";

const options = [
  { value: "1", label: "Joining Date (Newest First)" },
  { value: "2", label: "Joining Date (Oldest First)" },
  { value: "3", label: "Name (A–Z)" },
  { value: "4", label: "Name (Z–A)" },
];

export default function TeamMembers() {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const [searchtext, setSearchtext] = useState("");
  const [debouncedSearchtext, setDebouncedSearchtext] = useState(
    searchtext || ""
  );
  const [selectedOption, setselectedOption] = useState("");
  const [selectedOptionid, setselectedOptionid] = useState("");

  const dispatch = useDispatch();
  const allmembers = useSelector(
    ({ team: { getteammemberss } }) => getteammemberss
  );

  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchtext(searchtext);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchtext]);

  useEffect(() => {
    dispatch(getTeamMembers(selectedOptionid, debouncedSearchtext));
  }, [debouncedSearchtext, dispatch, selectedOptionid]);

  const { letChat } = useChatNavigation();

  return (
    <div>
      <div className="invite-member">
        <h4>Team Members</h4>
        <div className="search-bar">
          <input
            type="search"
            onChange={(e) => setSearchtext(e.target.value)}
            placeholder="Search expert"
            className="form-control"
          />
          <button className="btn search-btn">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/search-lg.svg`}
              alt=""
            />
          </button>
        </div>
      </div>
      <div className="row invite-row">
        <div className="col-md-6">
          <h6>
            Showing {allmembers?.length} of {allmembers?.length} members
          </h6>
        </div>
        <div className="col-md-6 invite-flex">
          <div className="select-flex">
            <p>Sort by :</p>
            <ReactSelect
              value={selectedOption}
              onChange={(option) => {
                setselectedOptionid(option.value);
                setselectedOption(option);
              }}
              options={options}
            />
          </div>
          <ul className="nav nav-tabs p-0">
            <li className="nav-item">
              <a
                className="nav-link active"
                data-toggle="tab"
                data-target="#list"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z"
                    stroke="#8D8D8D"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" data-target="#grid">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3Z"
                    stroke="#8D8D8D"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3Z"
                    stroke="#8D8D8D"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19.4 14H15.6C15.0399 14 14.7599 14 14.546 14.109C14.3578 14.2049 14.2049 14.3578 14.109 14.546C14 14.7599 14 15.0399 14 15.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V15.6C21 15.0399 21 14.7599 20.891 14.546C20.7951 14.3578 20.6422 14.2049 20.454 14.109C20.2401 14 19.9601 14 19.4 14Z"
                    stroke="#8D8D8D"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14Z"
                    stroke="#8D8D8D"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="tab-content list-grid">
        <div className="tab-pane active" id="list">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Expert name</th>
                  <th>Designation</th>
                  <th>Joining date</th>
                  {profile?.role_type == 4 && <th>Contact info</th>}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(allmembers) && allmembers.length > 0 ? (
                  allmembers.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <h5>
                          <img
                            src={item?.profile_image ? item.profile_image : ProfilePic}
                            alt=""
                          />
                          {decodeHtml(item?.first_name)} {decodeHtml(item?.last_name)}
                        </h5>
                      </td>
                      <td>
                        <h6>{decodeHtml(item?.designation)}</h6>
                      </td>
                      <td>{getDateFormate(item?.accepted_on)}</td>
                      {profile?.role_type == 4 && (
                        <td>
                          <p>
                            {item?.country_code} {item?.mobile_number}
                          </p>
                          <p>{item?.email_id}</p>
                        </td>
                      )}
                      <td>
                        <div className="action-btn">
                          {
                            item?.is_mine ? "" :
                              <>
                                <button
                                  className="btn"
                                  onClick={() => {
                                    navigate(`/${lan}/account/calendar`, {
                                      state: { id: item?.expert_id },
                                    });
                                  }}
                                >
                                  <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/calendar.svg`}
                                    alt=""
                                  />
                                </button>

                                <button
                                  onClick={() => letChat({ id: item?.id, user_id: item?.expert_id })}
                                  className="btn">
                                  <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/message-square.svg`}
                                    alt=""
                                  />
                                </button>
                              </>
                          }
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={profile?.role_type == 4 ? 5 : 4} className="text-center p-3">
                      No members found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="tab-pane" id="grid">
          <div className="row grid-row">
            {Array.isArray(allmembers) && allmembers.length > 0 ? (
              allmembers.map((item, index) => (
                <div className="col-md-4" key={index}>
                  <div className="grid-sec">
                    <img
                      className="profile"
                      src={item?.profile_image ? item.profile_image : ProfilePic}
                      alt=""
                    />
                    <h1>
                      {decodeHtml(item?.first_name)} {decodeHtml(item?.last_name)}
                    </h1>
                    <p>{decodeHtml(item?.designation)}</p>
                    <div className="joining">
                      <p>Joining date</p>
                      <h6>{getDateFormate(item?.accepted_on)}</h6>
                    </div>
                    <div className="joining">
                      <h6>
                        {item?.country_code} {item?.mobile_number}
                        <span>{item?.email_id}</span>
                      </h6>
                    </div>
                    <div className="joining action-btn">
                      {
                        item?.is_mine ? "" :
                          <>
                            <button
                            style={{background:'transparent'}}
                              className="btn"
                              onClick={() => {
                                navigate(`/${lan}/account/calendar`, {
                                  state: { id: item?.expert_id },
                                });
                              }}
                            >
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/common/calendar.svg`}
                                alt=""
                              />
                            </button>

                            <button style={{background:'transparent'}}
                              onClick={() => letChat({ id: item?.id, user_id: item?.expert_id })}>
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/common/message-square.svg`}
                                alt=""
                              />
                            </button>
                          </>
                      }
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center p-5">
                <h5>No members found</h5>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

// PREEMPTIVE HMR BURST
